// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

const BASE_URL = config.RATING_JOBS_URL;

function launchRatingJob(integrationId: string): any {
    const baseUrl = BASE_URL + '/create_and_launch';
    return api.create(`${baseUrl}?integrationId=${integrationId}`);
}

function getRatingJobStatus(integrationId: string): any {
    const baseUrl = BASE_URL + '/get_status';
    return api.get(`${baseUrl}?integrationId=${integrationId}`);
}

function stopRatingJob(integrationId: string): any {
    const baseUrl = BASE_URL + '/stop';
    return api.create(`${baseUrl}?integrationId=${integrationId}`);
}

function restartRatingJob(integrationId: string): any {
    const baseUrl = BASE_URL + '/restart';
    return api.create(`${baseUrl}?integrationId=${integrationId}`);
}

function getAllRatingJobs(): any {
    const baseUrl = BASE_URL;
    return api.get(baseUrl);
}

export {
    launchRatingJob,
    getRatingJobStatus,
    stopRatingJob,
    restartRatingJob,
    getAllRatingJobs,
};
